export default __webpack_public_path__ + "static/media/team-1.e875135d.png";